const singleProduct = function () {
    if (document.body.classList.contains('single-product')) {
        const h3 = document.querySelectorAll('.services-description h3');
        h3.forEach(item => {
            item.addEventListener('click', function () {
                item.classList.toggle('show');
            })
        });
    }
}

addFunctionOnWindowLoad(singleProduct);